import Vue from 'vue'

const state = {
  cidades: []
}

const mutations = {
  setCidades (state, data) {
    state.cidades = data
  }
}

const getters = {
  getCidadesEstadoCombo: state => {
    let cidades = []

    for (let i in state.cidades) {
      if (state.cidades[i] !== undefined) {
        if (cidades[state.cidades[i].estado_id]) {
          cidades[state.cidades[i].estado_id].push(state.cidades[i])
        } else {
          cidades[state.cidades[i].estado_id] = []
          cidades[state.cidades[i].estado_id].push(state.cidades[i])
        }
      }
    }

    return cidades
  }
}

const actions = {
  getCidades (context) {
    Vue.http.get('api/cidades').then(response => {
      context.commit('setCidades', response.data.data)
    })
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}



// WEBPACK FOOTER //
// ./src/vuex/modules/cidade.js